import { render } from "./Stillberatung.vue?vue&type=template&id=3b60d4c4&scoped=true"
import script from "./Stillberatung.vue?vue&type=script&lang=js"
export * from "./Stillberatung.vue?vue&type=script&lang=js"

import "./Stillberatung.vue?vue&type=style&index=0&id=3b60d4c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b60d4c4"]])

export default __exports__